module.exports = __webpack_public_path__ + "static/media/login-via-email-otp-logo.9da8e570.png";